const errorMessages = {
    3: "there is not enough liquidity to bridge your transfer",
    4: "the bridge rate has moved unfavorably by your slippage tolerance"
}

export default errorMessages;